var styleDataHash = '3ae10bb4';  
export const injectCss = (() => {
  var css = `.ezG-R{box-sizing:border-box;height:29px;max-width:100%;width:100%}[dir] .ezG-R{margin:0 auto;padding-top:14px}[dir] .flO6S{padding-top:11px}.ZzqH7{display:block;stroke:currentColor;stroke-width:1;shape-rendering:crispEdges}.Kx7iO,.PTBWF,._7XH9x,.g7mXF{height:100%}.Kx7iO{stroke-dasharray:4 4}._7XH9x{stroke-dasharray:1 5}.TAxyo{width:10%}.JOcbl{width:40%}._4GKdt{width:100%}[dir=ltr] .i52BP{margin-right:auto}[dir=rtl] .i52BP{margin-left:auto}[dir] .KtldG{margin:0 auto}[dir=ltr] .WyFhb{margin-left:auto}[dir=rtl] .WyFhb{margin-right:auto}.WGwr5{height:100%}.WGwr5 .GpRVB{height:1px}.Nukao{align-items:center;display:flex;height:38px}[dir=ltr] .Nukao{padding:0 30px 0 0!important}[dir=rtl] .Nukao{padding:0 0 0 30px!important}.ufw2r{height:18px;max-width:60px;overflow:hidden;width:60px}[dir] .ufw2r{padding-top:7px}._7TM4B{stroke:currentColor!important}.szhs4{width:100%}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "divider-container": "ezG-R",
  "divider-container--double": "flO6S",
  "divider": "ZzqH7",
  "divider--single": "g7mXF",
  "divider--double": "PTBWF",
  "divider--dashed": "Kx7iO",
  "divider--dotted": "_7XH9x",
  "divider--small": "TAxyo",
  "divider--medium": "JOcbl",
  "divider--large": "_4GKdt",
  "divider--left": "i52BP",
  "divider--center": "KtldG",
  "divider--right": "WyFhb",
  "svgFixerContainer": "WGwr5",
  "emptyChar": "GpRVB",
  "divider-dropdown__control": "Nukao",
  "divider-dropdown__option": "ufw2r",
  "divider-dropdown__divider": "_7TM4B",
  "divider_line_icon": "szhs4"
};